const ModalityData = ({
  Modality,
  CoverageFine,
  CoverageLabor,
  Sector,
  SubModality,
} = {}) => ({
  modality: Modality ?? '',
  coverageFine: CoverageFine ?? '',
  coverageLabor: CoverageLabor ?? '',
  sector: Sector ?? '',
  subModality: SubModality ?? '',
})

export default ModalityData
